module.exports = __webpack_public_path__ + "n.no1.6b6f07cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/n.no1.jpg
// module id = xNnj
// module chunks = 0